import { useEffect, useRef } from 'react';

// Pointer-driven 3D tilt: writes --rx / --ry (degrees) on the element so CSS
// decides how to use them. Only active with a fine pointer that can hover and
// when the user hasn't asked for reduced motion.
function useTilt(max = 5) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el || typeof window.matchMedia !== 'function') return undefined;
        const canTilt = window.matchMedia('(hover: hover) and (pointer: fine)').matches
            && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!canTilt) return undefined;

        const onMove = (e) => {
            const rect = el.getBoundingClientRect();
            const px = (e.clientX - rect.left) / rect.width - 0.5;
            const py = (e.clientY - rect.top) / rect.height - 0.5;
            el.style.setProperty('--rx', `${(-py * max * 2).toFixed(2)}deg`);
            el.style.setProperty('--ry', `${(px * max * 2).toFixed(2)}deg`);
        };
        const reset = () => {
            el.style.setProperty('--rx', '0deg');
            el.style.setProperty('--ry', '0deg');
        };

        el.addEventListener('pointermove', onMove);
        el.addEventListener('pointerleave', reset);
        return () => {
            el.removeEventListener('pointermove', onMove);
            el.removeEventListener('pointerleave', reset);
        };
    }, [max]);

    return ref;
}

export default useTilt;
